<template>
  <el-drawer title="查看UDI码" :visible="visible" size="60%" :destroy-on-close="true"
             :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看UDI码</div>
      <el-button @click="$emit('close')"> 返回</el-button>
    </div>
    <div class="card-shadown flex-container-between" style="margin-bottom: 12px">
      <div class="flex-container-start">
        <div style="width: 80px">产品名称:</div>
        <span> {{ productInfo.goodsName }}</span>
      </div>
      <div class="flex-container-start">
        <div style="width: 80px">规格型号:</div>
        <span> {{ productInfo.specification }}</span>
      </div>
      <div class="flex-container-start">
        <div style="width: 80px">包装层级:</div>
        <span> {{ productInfo.packLevel }}</span>
      </div>
      <div class="flex-container-start">
        <div style="width: 80px">已出库:</div>
        <span> {{ productInfo.quantifiedNumber }}</span>
      </div>
    </div>
    <div style="display: flex;justify-content: space-between">
      <el-button
        v-loading.fullscreen.lock="loading"
        size="mini"
        type="primary"
        @click="handleExport">
        导出UDI码
      </el-button>
      <div style="display: flex">
        <el-input v-model.trim="queryParams.searchValue" placeholder="UDI码" clearable style="width: 200px">
        </el-input>
        <div style="margin-left: 8px">
          <el-button size="mini" type="primary" @click="handleSearch">
            搜索
          </el-button>
        </div>
      </div>

    </div>

    <el-table @selection-change="handleSelectionChange" ref="table" height="500" :data="udiDataList"
              style="width: 100%; margin-top: 12px" border stripe>
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="udiCode" label="UDI码" show-overflow-tooltip/>
      <!--      待修改-->
      <el-table-column label="出库时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.inspectionDate ? formatDate(scope.row.inspectionDate, 'yyyy-MM-dd hh:mm:ss') : null }}
        </template>
      </el-table-column>
<!--      <el-table-column prop="state" label="状态" width="130">
        <template slot-scope="scope">
          <dict-tag v-if="scope.row.state" :options="dictObj.receiptDeliveryState" :value="scope.row.state" />
          <span v-else>已出库</span>
        </template>
      </el-table-column>-->
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="handlePerivew(scope.row)">查看内层UDI</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total > 0" style="margin-top: 24px" :total="total" :page-sizes="[10,50, 100, 300]"
                :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>
    <InnerLayerUdiDialog v-if="previewVisible" :visible="previewVisible" :complete-udi="completeUdi" @close="previewVisible=false"/>
  </el-drawer>
</template>

<script>
import InnerLayerUdiDialog from "@/components/InnerLayerUdiDialog";
import { exportUdiData, getInspectedList } from "@/api/orderManage";
import { formatDate } from "@/utils/date";

export default {
  name: 'OutboundUdiReview',
  components: {InnerLayerUdiDialog},
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    dictObj:{
      type:Object,
      default:()=>{
        return {
          receiptDeliveryState:[]
        }
      }
    },
    productInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => {
    return {
      udiDataList: [], // 列表数据
      selectList: [],// 选中列表
      queryParams: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        packLevel:'',
        ogoodsId: '',
        searchValue: '',
      },
      loading: false, // 是否显示遮罩
      previewVisible: false, // 查看详情
      total: 0, // 总条数
      completeUdi: {} // 查看详情数据
    }
  },
  mounted() {
    this.queryParams.ogoodsId = this.productInfo.ogoodsId
    this.queryParams.packLevel = this.productInfo.packLevel
    this.getList()
  },
  methods: {
    formatDate,
    handlePerivew(row) {
      this.previewVisible = true
      this.completeUdi = row.udiCode
    },
    // 处理选择
    handleSelectionChange(valList) {
      this.selectList = valList.map((item) => item.ogoodsInstId)
    },
    // 搜索
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    // 获取列表数据
    getList() {
      this.loading = true // 打开遮罩
      const params = JSON.parse(JSON.stringify(this.queryParams))
      getInspectedList(params)
        .then((res) => {
          this.udiDataList = res.rows
          this.total = res.total
        })
        .finally(() => {
          this.loading = false // 关闭遮罩
        })
    },
    // 导出
    handleExport() {
      if (this.total<=0) {
        this.$message({
          type: 'error',
          message: '暂无数据可导出'
        })
        return
      }
      let queryParams = {}
      queryParams = JSON.parse(JSON.stringify(this.queryParams))
      queryParams.pageSize = 99999999
      queryParams.pageNum = 1
      queryParams.udiCode = queryParams.searchValue
      if (this.selectList.length !== 0) {
        queryParams.idList = this.selectList
      }
      this.loading = true
      exportUdiData(queryParams).then((res) => {
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(res)
        link.download = '已出库UDI码.xlsx'
        link.click()
        this.loading = false
      })
        .catch(() => {
          this.loading = false
        })

    },
  }
}
</script>

